module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d3-mp3-player-container"
  }, [_c('div', {
    staticClass: "d3-mp3-player-container-body"
  }, [_c('img', {
    staticClass: "d3-mp3-player-thumbnail",
    attrs: {
      "src": _vm.content ? _vm.content.thumbnailUrl : null
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "d3-audio-container"
  }, [_c('audio', {
    ref: "player",
    staticClass: "d3-mp3-player-main",
    attrs: {
      "src": _vm.hasSignedCookie ? _vm.content.data.s3Url : null,
      "controls": ""
    }
  }), _vm._v(" "), (_vm.isChromeWithDownloadButton) ? _c('div', {
    staticClass: "d3-mp3-player-mask"
  }) : _vm._e()])]), _vm._v(" "), (!_vm.hasSignedCookie) ? _c('div', {
    staticClass: "d3-mp3-player-loading mdl-spinner mdl-js-spinner is-active"
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7ae32f25!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents/Mp3Player.vue
// module id = 1127
// module chunks = 38